import { PassengerRead } from 'src/common/external/bambi-api/bambiApi';

import { formatPassengerLabel } from './formatPassengerLabel';

import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

export function buildPassengerSelectOption(
  passenger: PassengerRead
): SelectOption {
  return {
    label: formatPassengerLabel(passenger),
    value: passenger.id,
  };
}
